/** API subscription list payloads use `6` for cancelled subscriptions (badge / status display). */
export const SUBSCRIPTION_STATUS_LISTING_CANCELLED = 6;
